import Vue from 'vue'
import App from 'client/components/app.vue'
import Router from 'client/js/router.js'
import VueGtm from '@gtm-support/vue2-gtm';
import store from 'client/js/store/store.js'
import { BTooltip,BootstrapVue } from 'bootstrap-vue'
import VueScrollactive from 'vue-scrollactive'
import VueClipboard from 'vue-clipboard2'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(BootstrapVue)
// Vue.component('b-tooltip', BTooltip)
Vue.use(VueScrollactive)
Vue.use(VueClipboard)
Vue.use(VueCompositionAPI)


// Import standard Murdoch components globally
// TODO: Manually define which components to include (if/when the number/variety grows larger than most projects use)
const layout = 'precedent'
const requireContext = require.context('client/components/murdoch', true, /.*\.vue$/)
const baseComponents = requireContext.keys()
   // Only keep top-level & matching layout sub-folder
   .filter(file => {
      let bits = file.split(/[\\\/]/)
      return bits.length == 2 || bits[1] == layout
   })
   .map(file => [file.replace(/(^.*\/)|(\.vue$)/g, ''), requireContext(file)])
   .reduce((components, [name, component]) => {
      components[name] = component.default || component
      return components
   }, {})
Object.keys(baseComponents).forEach(comp => {
   Vue.component(comp, baseComponents[comp]) //globally declares vue components
})

// Mixin functions
Vue.mixin({
   methods: {
      __: require("common/hbs-helpers/__")
   }
});

// Extra Style/Layout specific global components
// Vue.component('PageFooter', require('client/components'))
class VueJSUI {
   static init(baseUrl, pageData, analytics) {
      const router = Router(baseUrl, store)
      store.commit('global/setBaseUrl', baseUrl)
      if (pageData)
         store.commit('global/setPageData', pageData)
      if (analytics) {
         analytics.vueRouter = router
         // TODO: Following doesn't seem to do anything:
         analytics.vueRouterAdditionalEventData = () => ({
            // selectedCourse: () => store.userJourney.getSelectedCourse,
            foo: () => 'baa'
          }),
         Vue.use(VueGtm, analytics)
      }
      const app = new Vue({
         el: '#main-content',
         router,
         store,
         render: h => h(App)
      })
      store.$app = app
   }
}

module.exports = VueJSUI
